<template>
    <div class="home">
        <template v-if="configuracion">
            <LoadCssComponent :estilos="configuracion.css_front"/>
        </template>

        <template v-if="manager.tipo == 1">
            <LayoutSports/>
        </template>
        <template v-if="manager.tipo == 2">
            <LayoutTeatros/>
        </template>
    </div>
</template>

<script>
    import LayoutSports from './layouts/Sports.vue';
    import LayoutTeatros from './layouts/Teatros.vue';
    import LoadCssComponent from '@/components/css/LoadCssComponent.vue';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        components: {
            LayoutSports,
            LayoutTeatros,
            LoadCssComponent
        },
        created() {
            useHead('Home');
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>
